/**
 * Where the person is, told to the Assistant with every message.
 *
 * The section and its tab are the app's own. Every other part of the app that
 * lent the Assistant tools describes its own screen through `registerPagePart`
 * - an open editor, an open item - under the key its backend extension reads.
 * The chat knows that parts exist, never which ones, as with cards
 * (`assistant-cards.ts`).
 */

import type { AssistantPageContext } from '../../api/types.ts';
import { activeModelTab, activeSection, activeTab, assistantTab } from '../../state/store.ts';

export type PagePart = () => Record<string, unknown> | null;

const parts = new Map<string, PagePart>();

export function registerPagePart(key: string, describe: PagePart): void {
  parts.set(key, describe);
}

function view(): string | null {
  switch (activeSection.value) {
    case 'explore':
      return activeTab.value === 'modelviewer' ? activeModelTab.value : activeTab.value;
    case 'assistant':
      return assistantTab.value;
    default:
      return null;
  }
}

export function buildPageContext(): AssistantPageContext {
  const described: Record<string, Record<string, unknown>> = {};
  for (const [key, describe] of parts) {
    try {
      const part = describe();
      if (part) described[key] = part;
    } catch {
      // A part that cannot describe itself is left out; the message still goes.
    }
  }
  return { section: activeSection.value, view: view(), parts: described };
}
